import CreateReportDialog from './CreateReportDialog';
export default CreateReportDialog;



// WEBPACK FOOTER //
// ./src/scenes/Reports/components/ReportList/components/CreateReportDialog/index.js